export default "__VITE_ASSET__ej9E6wtP__"